import { Host, h } from '@stencil/core';
export class AibaSelectNative {
  constructor() {
    this.getOptions = options => {
      const select = this.selectValue;
      return options.map((item, index) => {
        return (h("option", { key: index, value: item, selected: item === select }, item));
      });
    };
    this.disabled = false;
    this.id = undefined;
    this.label = undefined;
    this.name = undefined;
    this.ariaLabel = undefined;
    this.placeHolderValue = 'Make a Selection';
    this.selectValue = undefined;
    this.onSelect = undefined;
    this.error = undefined;
    this.options = undefined;
    this.onBlur = undefined;
  }
  render() {
    return (h(Host, null, this.label && h("label", { innerHTML: this.label, htmlFor: this.id }), h("select", { key: this.id + Math.random(), onChange: this.onSelect, class: `aiba-select-native`, id: this.id, name: this.name, "aria-label": this.ariaLabel, disabled: this.disabled, onBlur: this.onBlur }, h("option", { value: "", disabled: true, selected: true }, this.placeHolderValue), this.getOptions(this.options)), this.error && h("span", { class: "select-error" }, this.error), h("span", { class: "state" })));
  }
  static get is() { return "aiba-select-native"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-select-native.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-select-native.css"]
    };
  }
  static get properties() {
    return {
      "disabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "id",
        "reflect": false
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label",
        "reflect": false
      },
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false
      },
      "ariaLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "aria-label",
        "reflect": false
      },
      "placeHolderValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "place-holder-value",
        "reflect": false,
        "defaultValue": "'Make a Selection'"
      },
      "selectValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "select-value",
        "reflect": false
      },
      "onSelect": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-select",
        "reflect": false
      },
      "error": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "error",
        "reflect": false
      },
      "options": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "onBlur": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-blur",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-select-native.js.map
